import {NewMarkdownViewer} from '@github-ui/markdown-viewer/NewMarkdownViewer'
import {FileIcon} from '@primer/octicons-react'
import {ActionList, Label, NavList, SplitPageLayout} from '@primer/react'
import {shortOid} from '../toolbar/timeline-panel/issue-events/short-oid'
import {ArtifactMetadata} from './ArtifactMetadata'
import {ArtifactsBlankSlate} from './ArtifactsBlankSlate'
import {useSelectedPullRequestArtifact} from './use-selected-pull-request-artifact'
import styles from './ArtifactsContent.module.css'

export const ArtifactsContent = () => {
  // TODO: Announce loading, error, empty, and artifact selection changes to screen readers.
  const {artifacts, isPending, isLoadingError, selectedArtifact, setSelectedNumber} = useSelectedPullRequestArtifact()
  if (isPending) return <ArtifactsBlankSlate heading="Loading artifacts…" />
  if (isLoadingError) return <ArtifactsBlankSlate heading="Unable to load artifacts" />

  if (artifacts.length === 0) {
    return (
      <ArtifactsBlankSlate
        heading="No artifacts yet"
        description="Artifacts created for this pull request will appear here"
      />
    )
  }

  return (
    <SplitPageLayout>
      <SplitPageLayout.Pane position="start" sticky={false} padding="condensed">
        <NavList aria-label="Artifacts">
          <NavList.Heading as="h2">Artifacts</NavList.Heading>
          {artifacts.map(artifact => (
            <ActionList.Item
              key={artifact.id}
              onSelect={() => setSelectedNumber(artifact.number)}
              active={selectedArtifact?.id === artifact.id}
              aria-current={selectedArtifact?.id === artifact.id ? true : undefined}
            >
              <span className={styles.ArtifactName}>{artifact.name}</span>
            </ActionList.Item>
          ))}
        </NavList>
      </SplitPageLayout.Pane>
      <SplitPageLayout.Content as="div" width="full">
        {selectedArtifact ? (
          <section aria-labelledby="selected-artifact-heading" className={styles.Artifact}>
            <div className={styles.Header}>
              <h2 id="selected-artifact-heading" className={styles.Heading}>
                {selectedArtifact.name}
              </h2>
              {selectedArtifact.commit_oid && (
                <Label className={styles.Sha}>{shortOid(selectedArtifact.commit_oid)}</Label>
              )}
            </div>
            <ArtifactMetadata artifact={selectedArtifact} />
            <div className={styles.File}>
              <div className={styles.FileHeader}>
                <FileIcon className={styles.FileIcon} />
                <span className={styles.FileName}>{selectedArtifact.name}</span>
                <span>Markdown preview</span>
              </div>
              <div className={styles.FileBody}>
                <NewMarkdownViewer key={selectedArtifact.id} verifiedHTML={selectedArtifact.body} />
              </div>
            </div>
          </section>
        ) : (
          <ArtifactsBlankSlate heading="Artifact not found" description="Select an artifact from the sidebar" />
        )}
      </SplitPageLayout.Content>
    </SplitPageLayout>
  )
}
